export const EventTypesOptions = [
  { id: 'Bryllup', label: 'Bryllup' },
  { id: 'Fødselsdagsfest', label: 'Fødselsdagsfest' },
  { id: 'Konfirmation', label: 'Konfirmation' },
  { id: 'Jubilæum', label: 'Jubilæum' },
  { id: 'Julefrokost', label: 'Julefrokost' },
  { id: 'Frokostarrangement', label: 'Frokostarrangement' },
  { id: 'Firmaarrangement', label: 'Firmaarrangement' },
  { id: 'Sommerfest', label: 'Sommerfest' },
  { id: 'Møde', label: 'Møde' },
  { id: 'Konference', label: 'Konference' },
  { id: 'Andet', label: 'Andet' },
  { id: 'Kursus', label: 'Kursus' },
];


export const timeStamps = [
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
];


export const phoneCodes = [
  { country: 'denmark', id: '45', label: '+45' },
  { country: 'sweden', id: '46', label: '+46' },
  { country: 'norway', id: '47', label: '+47' },
  { country: 'poland', id: '48', label: '+48' },
  { country: 'germany', id: '49', label: '+49' },
  { country: 'faroe_islands', id: '298', label: '+298' },
  { country: 'greenland', id: '299', label: '+299' },
];
